import React from 'react'
import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material'
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom'

const Breadcrumbs = ({ items }) => {
  return (
    <MuiBreadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      {items.map((item, index) =>
        index === items.length - 1 ? (
          <Typography key={index} color="text.primary">
            {item.title}
          </Typography>
        ) : (
          <Link
            key={index}
            component={RouterLink}
            to={item.url}
            color="inherit"
            underline="hover"
          >
            {item.title}
          </Link>
        ),
      )}
    </MuiBreadcrumbs>
  )
}

// Проп по умолчанию для случая, если items не передали
Breadcrumbs.defaultProps = {
  items: [],
}

export default Breadcrumbs
